import { usd } from "@/components/ai/useAiEdits";
import { fmtN, pl, SOURCES } from "./helpers";

export function Breakdown({ title, rows, name, testid }) {
  const total = rows.reduce((a, r) => a + (r.usd || 0), 0);
  return (
    <section className="rounded-xl border border-slate-200 bg-white p-5 min-w-0" data-testid={testid}>
      <h2 className="text-base font-semibold text-slate-900">{title}</h2>
      {!rows.length && <p className="mt-4 text-sm text-slate-500">Nessun consumo nel periodo selezionato.</p>}
      <ul className="mt-4 space-y-3">
        {rows.map((r, i) => {
          const pct = total ? Math.round((r.usd / total) * 100) : 0;
          return (
            <li key={i} data-testid={`${testid}-row-${i}`}>
              <div className="flex items-baseline justify-between gap-3 text-sm">
                <span className="min-w-0 truncate text-slate-800">{name(r)}</span>
                <span className="shrink-0 font-semibold tabular-nums text-slate-900">{usd(r.usd)}</span>
              </div>
              <div className="mt-1 h-1 rounded-full bg-slate-100 overflow-hidden"><div className="h-full bg-sky-600 rounded-full" style={{ width: `${pct}%` }} /></div>
              <p className="mt-1 text-[11px] text-slate-500 tabular-nums">{pl(r.calls, "chiamata", "chiamate")}{r.failed ? ` (${pl(r.failed, "fallita", "fallite")})` : ""} · {fmtN(r.input_tokens)} in / {fmtN(r.output_tokens)} out{r.images ? ` · ${pl(r.images, "immagine", "immagini")}` : ""} · {pct}%</p>
            </li>
          );
        })}
      </ul>
    </section>
  );
}

export const modelName = (providers) => (r) => `${providers[r.provider] || r.provider} · ${r.model} · ${SOURCES[r.key_source] || r.key_source}`;
